export class CargoEventName {
    // Booking Events
    static readonly FmsBooking: string = "booking";

    // Transport, Raw Events
    static readonly EmptyOut: string = "empty_out";
    static readonly FullIn: string = "full_in";
    static readonly PositionedIn: string = "positioned_in";
    static readonly PositionedOut: string = "positioned_out";
    static readonly VesselLoaded: string = "vessel_loaded";
    static readonly VesselDeparted: string = "vessel_departed";
    static readonly TransShipArrived: string = "transshipment_arrived";
    static readonly TransShipDischarged: string = "transshipment_discharged";
    static readonly TransShipLoaded: string = "transshipment_loaded";
    static readonly TransShipDeparted: string = "transshipment_departed";
    static readonly FeederArrived: string = "feeder_arrived";
    static readonly FeederDischarged: string = "feeder_discharged";
    static readonly FeederLoader: string = "feeder_loaded";
    static readonly FeederDeparted: string = "feeder_departed";
    static readonly VesselArrived: string = "vessel_arrived";
    static readonly VesselBerthed: string = "vessel_berthed";
    static readonly VesselDischarged: string = "vessel_discharged";
    static readonly FmsDlvrToCfs: string = "cfs_delivered";
    static readonly FullOut: string = "full_out";
    static readonly EmptyIn: string = "empty_in";
    static readonly RailLoaded: string = "rail_loaded";
    static readonly RailDeparted: string = "rail_departed";
    static readonly RailArrived: string = "rail_arrived";
    static readonly RailUnloaded: string = "rail_unloaded";

    // Container Updated Events
    static readonly PickAvail: string = "available_for_pickup";
    static readonly PickLfd: string = "pickup_lfd";
    static readonly TerminalFee: string = "fees_at_pod_terminal";
    static readonly TerminalHold: string = "holds_at_pod_terminal";
    static readonly PodTml: string = "pod_terminal";
    static readonly PickAppointment: string = "pickup_appointment_at";

    // Shipment Estimated Arrival Events
    static readonly EtaChange: string = "eta_change";

    // Container POD Terminal Changed Event
    static readonly PodTmlChanged: string = "pod_terminal_changed";

    // Raw Events
    static readonly DestArrived: string = "arrived_at_destination";
    static readonly Delivered: string = "delivered";
    static readonly VgmReceived: string = "vgm_received";
    static readonly CarrierRls: string = "carrier_release";
    static readonly CustomsRls: string = "customs_release";
}